<template>
  <div class="banner">
    <slot>
      <swiperCpt
        class="swiperBanner"
        ref="swiperBanner"
        :slidesPerView="1"
        :loop="false"
        :delay="5000"
        :autoplay="true"
        :isShowPagination="banner_img.length > 1"
        sid="swiperBanner"
        v-if="isShow"
      >
        <div
          class="swiper-slide"
          v-for="(item, index) in banner_img"
          :key="'swiperBanner' + index"
        >
          <router-link
            v-if="item.skipHref"
            class="hrefLink"
            :to="item.skipHref"
          ></router-link>
          <img class="animated fadeInUpBanner" :src="item.imageUrl" />
          <!-- <img
            class="animated fadeInUpBanner"
            :src="$store.state.baseUrl + item.imageUrl"
          /> -->
          <div class="crilebg mainBody fadeInUp1 animated">
            <div
              class="crilebg_cn"
              :style="{
                'animation-delay': 1 * 0.6 + 's',
                '-webkit-animation-delay': 1 * 0.6 + 's',
              }"
            >
              {{ banner_cn }}
            </div>
            <div
              class="crilebg_en"
              :style="{
                'animation-delay': 1 * 0.6 + 's',
                '-webkit-animation-delay': 1 * 0.6 + 's',
              }"
            >
              {{ banner_en }}
            </div>
            <div class="unLine">
              <i class="point"></i>
              <span class="line"></span>
            </div>
          </div>
        </div>
      </swiperCpt>
    </slot>
    <div
      v-if="banner_img.length > 1"
      class="swiperBtn swiperBtn_left"
      @click="onSwipePrev"
    ></div>
    <div
      v-if="banner_img.length > 1"
      class="swiperBtn swiperBtn_right"
      @click="onSwipeNext"
    ></div>
  </div>
</template>

<script>
import swiperCpt from '@/components/common/swiperCpt.vue'
export default {
  name: 'Bannner',
  props: ['banner_img', 'banner_en', 'banner_cn'],
  data() {
    return {
      isShow: true,
    }
  },
  components: {
    swiperCpt,
  },
  methods: {
    reInitBanner() {
      // console.log(this.banner_img)
      this.$refs.swiperBanner.swiperSl.reInit()
    },
    onSwipeNext() {
      this.$refs.swiperBanner.swiperSl.swipeNext()
    },
    onSwipePrev() {
      this.$refs.swiperBanner.swiperSl.swipePrev()
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  .swiperBtn {
    width: 40px;
    height: 70px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    margin-top: -35px;
    z-index: 66;
    &.swiperBtn_left {
      left: 0;
      background: rgba($color: #c2c3be, $alpha: 0.5)
        url('../../assets/images/common/btn_left.png');
      background-size: cover;
      &:hover {
        background: rgba($color: #fff, $alpha: 0.5)
          url('../../assets/images/common/btn_left.png');
        background-size: cover;
      }
    }
    &.swiperBtn_right {
      right: 16px;
      background: rgba($color: #c2c3be, $alpha: 0.5)
        url('../../assets/images/common/btn_right.png');
      background-size: cover;
      &:hover {
        background: rgba($color: #fff, $alpha: 0.5)
          url('../../assets/images/common/btn_right.png');
        background-size: cover;
      }
    }
  }
}
.swiper-slide {
  position: relative;

  .hrefLink {
    display: block;
    width: 100%;
    height: 22.4vw;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
}

.banner {
  width: 100%;
  // min-height: 22.4vw;
  position: relative;
  .swiperBanner {
    width: 100%;
    position: relative;
  }
  img {
    width: 100%;
    display: block;
  }
}

.crilebg {
  position: absolute;
  width: 72.92vw;
  left: 50%;
  top: 4.69vw;
  margin-left: -36.46vw;

  .crilebg_en {
    font-size: 1.25vw;
    color: #ffffff;
    margin-top: 1.04vw;
  }

  .crilebg_cn {
    font-size: 1.88vw;
    color: #fff;
    font-weight: 700;
    letter-spacing: 0.52vw;
  }
}
.unLine {
  width: auto;
  height: 0.21vw;
  margin-top: 2.34vw;
  box-sizing: border-box;
  .point {
    display: inline-block;
    width: 0.42vw;
    height: 0.21vw;
    border-radius: 0.26vw;
    background: #87c31e;
  }
  .line {
    width: 3.44vw;
    height: 0.21vw;
    border-radius: 0.26vw;
    background: #87c31e;
    margin-left: 0.21vw;
    display: inline-block;
  }
}

@media (min-width: 1920px) {
  .crilebg {
    position: absolute;
    width: 1400px;
    left: 50%;
    top: 90px;
    margin-left: -700px;

    .crilebg_en {
      font-size: 24px;
      color: #ffffff;
      margin-top: 20px;
    }

    .crilebg_cn {
      font-size: 36px;
      color: #fff;
      font-weight: 700;
      letter-spacing: 10px;
    }
  }
  .unLine {
    width: auto;
    height: 4px;
    margin-top: 45px;
    box-sizing: border-box;
    .point {
      display: inline-block;
      width: 8px;
      height: 4px;
      border-radius: 5px;
      background: #87c31e;
    }
    .line {
      width: 66px;
      height: 4px;
      border-radius: 5px;
      background: #87c31e;
      margin-left: 4px;
      display: inline-block;
    }
  }
}
</style>
